import { useEffect, useRef, useState } from "react";
import { Button } from "../../../components/ui";
import homeService from "../services/home.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign, } from "@fortawesome/free-solid-svg-icons";
import { toastService as toast } from "../../../components/ui/toast/toast.service";
import { GameHistoryListResponse } from "../models/";
import localization from "../../../config/localization";
import { getAvatarById } from "../../users/components/avatar/avatar.config";
import userDeviceStore from "../../../store/device.store";
import { DeviceType } from "../../../models/constants/deviceType";

export function BetHistory() {
  const tabs = [
    { title: localization.casino_bet, value: "casino" },
    { title: localization.sports_bet, value: "sports" },
  ];

  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [active, setActive] = useState("casino");
  const [historyData, setHistoryData] = useState<GameHistoryListResponse>();

  const deviceType = userDeviceStore((state) => state.deviceType);

  const scrollToTop = () => {
    scrollRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  const fecthCasinoHistory = async (value?: string) => {
    await homeService
      .fetchGameHistory({
        vertical: value ?? "casino",
      })
      .then((response) => {
        if (response.isSuccess) {
          setHistoryData(response.data ?? undefined);
        } else {
          toast.error(response.message || "Failed to fetch casino history");
        }
      });
  };

  useEffect(() => {
    fecthCasinoHistory();
  }, [active]);

  const handleChangeVertical = (value: string) => {
    scrollToTop();
    setActive(value);
    fecthCasinoHistory(value);
  };

  let columns = deviceType === DeviceType.Web ? 4 : 3;

  return (
    <div className="mt-5 bg-[#272727] rounded-md p-4 overflow-hidden">
      <div className="bg-[#1E1E1E] rounded-md p-2 mb-3">
        <div className="gap-2 flex">
          {tabs.map((tab) => {
            const isActive = active === tab.value;
            return (
              <Button
                key={tab.value}
                onClick={() => handleChangeVertical(tab.value)}
                className={`${deviceType === DeviceType.Web ? "w-1/6" : "w-full"} h-12 rounded-md text-md hover:opacity-90
                ${isActive ? "bg-deep-red text-white" : "bg-gray-800 text-gray-400"}`}
              >
                <span className="mt-3">{tab.title}</span>
              </Button>
            );
          })}
        </div>
      </div>

      <div className="w-full  overflow-y-auto pr-1 scrollbar-hide max-h-[500px]" ref={scrollRef}>
        <div className="flex justify-between text-gray-400 text-md px-2 py-2 border-b border-gray-700">
          <div className={`w-1/${columns} uppercase font-bold tracking-wider`}>{localization.game}</div>
          <div className={`w-1/${columns} uppercase font-bold tracking-wider ${deviceType !== DeviceType.Web ? "text-center" : ""}`}>{localization.player}</div>
          {deviceType === DeviceType.Web && <div className={`w-1/${columns} text-center uppercase font-bold tracking-wider`}>{localization.bet_amount}</div>}
          <div className={`w-1/${columns} text-right uppercase font-bold tracking-wider`}>{localization.payout}</div>
        </div>

        <div>
          {historyData?.details.map((item, i) => (
            <div
              key={i}
              className="flex items-center justify-between px-2 py-3 border-b border-gray-800 bg-black bottom-1 rounded-md mb-2"
            >
              <div className={`w-1/${columns} text-white ml-1`}>{item?.betType !== "Single" ? item?.betType : item?.game}</div>

              <div className={`w-1/${columns} ${deviceType !== DeviceType.Web ? "justify-center" : ""} flex gap-2 `}>
                <img src={getAvatarById(item?.avatarUrl ?? null) ?? "/images/avatar.svg"} alt="avatar" className="w-7 h-7 rounded-full" />
                <span className="text-white lowercase">{item.userName}</span>
              </div>

              {deviceType === DeviceType.Web && <div className={`w-1/${columns} text-center`}>
                <span>
                  <FontAwesomeIcon icon={faIndianRupeeSign} />
                  {item.betAmount.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>}
              <div
                className={`w-1/${columns} text-right ${["win", "won"].includes(item.status.toLowerCase())
                  ? "text-green-400"
                  : ["lose", "lost"].includes(item.status.toLowerCase())
                    ? "text-red-400"
                    : ""
                  }`}
              >
                <span>
                  <FontAwesomeIcon icon={faIndianRupeeSign} />
                  {Math.abs(item.payout).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>
            </div>
          ))}
          {historyData?.details.length === 0 && (
            <div className="text-center text-gray-400 text-md px-2 py-2 border-b border-gray-700">
              {localization.no_records_found}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
